/**
 * ES Sticky UI Controller
 * - Product page only: sticky add-to-cart reveal
 * - Keeps --es-header-h in sync for PDP sticky layout helpers
 * - Old mobile bottom toolbar reveal removed
 */
(function () {
  'use strict';

  var previous = window.__esStickyUiState || null;
  if (previous && typeof previous.cleanup === 'function') {
    try { previous.cleanup(); } catch (e) {}
  }

  var sticky = null;
  var bound = false;
  var pageHideBound = false;
  var ticking = false;
  var resizeTicking = false;
  var lastY = 0;

  function qs(sel, root) {
    return (root || document).querySelector(sel);
  }

  function isProductPage() {
    return !!(document.body && document.body.classList.contains('template-product'));
  }

  function refreshRefs() {
    sticky = qs('.sticky_addcart');
  }

  function setHeaderHeightVar() {
    var headerEl = qs('#shopify-section-header') || qs('header') || qs('.site-header') || qs('.header');
    if (!headerEl) return;
    var h = headerEl.getBoundingClientRect().height || headerEl.offsetHeight || 0;
    if (h > 0) {
      document.documentElement.style.setProperty('--es-header-h', Math.round(h) + 'px');
    }
  }

  function setStickyActive(active) {
    if (!sticky) return;
    sticky.classList.toggle('active', !!active);
  }

  function update() {
    ticking = false;
    if (!isProductPage()) return;

    refreshRefs();
    if (!sticky) return;

    var w = window.innerWidth || document.documentElement.clientWidth || 1024;
    var threshold = w > 1024 ? 100 : 300;
    setStickyActive(lastY >= threshold);
  }

  function requestUpdate() {
    if (ticking) return;
    ticking = true;
    window.requestAnimationFrame(update);
  }

  function onScroll() {
    lastY = window.pageYOffset || document.documentElement.scrollTop || 0;
    requestUpdate();
  }

  function onResize() {
    if (resizeTicking) return;
    resizeTicking = true;
    window.requestAnimationFrame(function () {
      resizeTicking = false;
      setHeaderHeightVar();
      lastY = window.pageYOffset || document.documentElement.scrollTop || 0;
      update();
    });
  }

  function bind() {
    if (bound) return;
    bound = true;
    window.addEventListener('scroll', onScroll, { passive: true });
    window.addEventListener('resize', onResize);
  }

  function unbind() {
    if (!bound) return;
    bound = false;
    try {
      window.removeEventListener('scroll', onScroll, { passive: true });
    } catch (e) {
      window.removeEventListener('scroll', onScroll);
    }
    window.removeEventListener('resize', onResize);
  }

  function init() {
    if (!isProductPage()) return;
    refreshRefs();
    lastY = window.pageYOffset || document.documentElement.scrollTop || 0;
    setHeaderHeightVar();
    bind();
    update();
  }

  function cleanup() {
    unbind();
    ticking = false;
    resizeTicking = false;
  }

  function handlePageShow() {
    init();
    requestUpdate();
  }

  function handlePageHide() {
    cleanup();
  }

  init();

  if (!pageHideBound) {
    pageHideBound = true;
    window.addEventListener('pageshow', handlePageShow);
    window.addEventListener('pagehide', handlePageHide);
  }

  window.__esStickyUiState = {
    cleanup: function () {
      try { window.removeEventListener('pageshow', handlePageShow); } catch (e) {}
      try { window.removeEventListener('pagehide', handlePageHide); } catch (e) {}
      cleanup();
    }
  };
})();
